import { PilotId } from '~/eds/src/types/PilotId';
import { BulkEditFieldType } from '~/features/document-bulk-actions/types';
import { UfFieldValue } from '~/features/unified-fields/questionInputRegistry';
import { pilot } from '~/services/serviceInstances';

type Field = {
  id: PilotId;
  keepOldValues: boolean;
  value: string | string[] | number | null;
  ufFieldId?: string;
  ufFieldValue?: { data: UfFieldValue[] };
};

interface Request {
  type: BulkEditFieldType;
  documentIds?: PilotId[];
  searchQuery?: object;
  searchAPI: 'v2' | 'v3';
  isAllSelected?: boolean;
  /** Used when type is 'delete' */
  fieldIds?: PilotId[];
  /** Used when type is 'delete' */
  ufFieldIds?: string[];
  /** Used when type is 'add/replace' */
  fieldUpdates?: Field[];
}

type Params = {
  type: BulkEditFieldType;
  document_ids?: PilotId[];
  query?: object;
  field_ids?: PilotId[];
  uf_field_ids?: string[];
  field_updates?: {
    id: PilotId;
    value: string | string[] | number | null;
    keep_old_values: boolean;
    uf_field_id?: string;
    uf_field_value?: { data: UfFieldValue[] };
  }[];
};
export const documentBulkEditFields = (
  request: Request,
): Promise<{ detail: string }> =>
  pilot.post('document/bulk-edit-field/', mapRequestToParams(request));

const mapRequestToParams = ({
  type,
  documentIds,
  fieldIds,
  ufFieldIds,
  fieldUpdates,
  searchQuery,
  searchAPI,
  isAllSelected,
}: Request): Params => {
  let searchSpread: { query?: object; query_v3?: object } | undefined;
  if (isAllSelected) {
    if (searchAPI === 'v3') {
      searchSpread = { query_v3: searchQuery };
    } else {
      searchSpread = { query: searchQuery };
    }
  }

  return {
    document_ids: !isAllSelected && documentIds ? documentIds : [],
    field_ids: fieldIds,
    uf_field_ids: ufFieldIds,
    field_updates: fieldUpdates?.map(
      ({ id, keepOldValues, value, ufFieldId, ufFieldValue }) => ({
        id,
        value,
        keep_old_values: keepOldValues,
        ...(ufFieldId
          ? { uf_field_id: ufFieldId, uf_field_value: ufFieldValue }
          : undefined),
      }),
    ),
    ...searchSpread,
    type,
  };
};
